// extracted by mini-css-extract-plugin
export var chevronIcon = "_9x-2";
export var teamName = "_9x-1";
export var teamSwitcherButton = "_9x-0";